import { render, staticRenderFns } from "./OrderReporting.vue?vue&type=template&id=4daefb29"
import script from "./OrderReporting.vue?vue&type=script&lang=js"
export * from "./OrderReporting.vue?vue&type=script&lang=js"
import style0 from "./OrderReporting.vue?vue&type=style&index=0&id=4daefb29&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VAlert,
  VAutocomplete,
  VBtn,
  VCard,
  VDataTable,
  VDatePicker,
  VDialog,
  VFlex,
  VForm,
  VIcon,
  VLayout,
  VMenu,
  VProgressLinear,
  VSpacer,
  VTextField,
  VToolbar,
  VToolbarItems,
  VToolbarTitle,
})
